export const lineChartData = {
  labels: [] as string[],
  datasets: [
    {
      label: '',
      fill: false,
      lineTension: 0,
      backgroundColor: "#F075A2",
      borderColor: "#F075A2",
      borderCapStyle: "butt",
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: "miter",
      pointBorderColor: "#F075A2",
      pointBackgroundColor: "#fff",
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: "#F075A2",
      pointHoverBorderColor: "#F075A2",
      pointHoverBorderWidth: 2,
      pointRadius: 4,
      pointHitRadius: 10,
      data: [] as number[],
      spanGaps: false
    }
  ],
  baseLine: 1,
  baseLineColor: "#E37B40"
};

export const lineChartOptions = {
  maintainAspectRatio: false,
  responsive: true,
  scales: {
    yAxes: [{
      gridLines: {
        color: "rgba(255,255,255,0.25)",
        zeroLineColor: "rgba(255,255,255,0.5)"
      }, ticks: {
        reverse: true,
        min: 1,
        suggestedMax: 10,
        fontColor: "#fff",
        fontFamily: "Source Sans Pro",
        fontSize: 14,
        fontStyle: "300"
      },
      scaleLabel: {
        display: true,
        labelString: '',
        fontColor: "#fff"
      }
    }],
    xAxes: [{
      gridLines: {
        color: "rgba(255,255,255,0.25)",
        zeroLineColor: "rgba(255,255,255,0.5)"
      },
      ticks: {
        fontColor: "#fff",
        fontFamily: "Source Sans Pro",
        fontSize: 14,
        fontStyle: "300"
      }
    }]
  },
  legend: {
    display: true,
    position: "bottom",
    labels: {
      boxWidth: 14,
      fontFamily: "Source Sans Pro",
      fontSize: 14,
      fontColor: "#fff",
      fontStyle: "300"
    }
  }
};